import { CircleAlert } from 'lucide-react';
import { CustomFieldDefinition } from '__types__';
import { FilterStringConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createFallbackFilterConfig(
  customFieldDef: CustomFieldDefinition
): FilterStringConfig {
  return {
    label: customFieldDef.name,
    icon: <CircleAlert />,
    type: 'string' as const,
    createDefaultValue: () => ({ operator: 'contains', value: '' }),
    options: {
      placeholder: `Search by ${customFieldDef.name.toLowerCase()}`
    }
  };
}
